/**
 * Gets the values of an object as an array.
 *
 * @param obj - The object to get values from
 * @returns An array of the object's values
 */
export default function getObjectValues<T>(obj: { [key: string]: T }): T[] {
    const values: T[] = [];
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            values.push(obj[key]);
        }
    }
    return values;
}